/* eslint-disable */

import {THEMES} from "./themes";

export const LDA_TENANT_ID = 'b1afbb90-f529-468e-8f0c-a0c35809a694';

export const FUNCTION_ROLES = {
  SEARCH: 'ad5f4e3d-cb02-4877-8ee1-4773e6086896',
  ANALYSIS: '33070d15-75fd-4d83-a60a-d68454ac1573',
  EDITOR: '6a12c4a0-7d66-4a78-baa3-207b26ffa419',
  NKR: '1ccdff14-34d8-4d4f-a4c7-412582895898',
};

export const THEME_ROLES = {
  [THEMES.OTTO_SCHMIDT]: 'b02ded14-7113-4634-8590-ee288d51a0c8',
  [THEMES.REHM]: 'fc8ec186-da25-431e-aed7-511d98ce4021',
  [THEMES.REGUVIS]: '98fcf634-a2f3-489e-8538-305ea2cc823f',
  [THEMES.MOHR_SIEBECK]: 'dc5649ae-1e0d-4687-b6dc-61baebe71481',
  [THEMES.NKR]: '99ddf841-0c60-45db-8900-76da350f52ba',
  [THEMES.LINDE]: '11318b23-6146-4f1d-946d-cb97b10de454',
  [THEMES.ERICH_SCHMIDT]: 'd4ff9283-8f5f-4acf-bca5-bf3f5ed2a1ab',
  [THEMES.STAEMPFLI]: '2d8181e2-498c-407b-91f3-f084ae787c82',
};

const DEFAULT_BRAND_CONFIG = {
  brandLabel: 'LDH Explorer',
  website: 'https://www.legal-data-analytics.com/',
  companyName: 'LDA Legal Data Analytics GmbH',
  legalLinks: {
    disclaimer: '/disclaimer',
    nutzungsbedingungen:
      'https://www.legal-data-analytics.com/impressum',
    datenschutz: 'https://www.legal-data-analytics.com/datenschutz-und-privatsph%C3%A4re',
    impressum: 'https://www.legal-data-analytics.com/impressum',
  },
};

export const THEME_META = {
  [THEMES.LDA_LIGHT]: {
    label: 'LDH Explorer Theme – LDA Explorer',
    brandLabel: 'LDH Explorer',
    alwaysAvailable: true,
    brandConfig: {
      ...DEFAULT_BRAND_CONFIG,
    },
  },

  [THEMES.LDA_DARK]: {
    label: 'LDH Explorer Theme – Dark',
    brandLabel: 'LDH Explorer',
    alwaysAvailable: false,
    brandConfig: {
      ...DEFAULT_BRAND_CONFIG,
    },
  },

  [THEMES.OTTO_SCHMIDT]: {
    label: 'LDH Explorer Theme – Otto-Schmidt Assist',
    brandLabel: 'OS Assist',
    roleId: THEME_ROLES[THEMES.OTTO_SCHMIDT],
    brandConfig: {
      brandLabel: 'OS Assist',
      website: 'https://www.otto-schmidt.de/',
      companyName: 'Verlag Dr. Otto Schmidt KG',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen:
          'https://www.otto-schmidt.de/daten/assist/Nutzungsbedingungen_OS_Assist.pdf',
        datenschutz: 'https://www.otto-schmidt.de/datenschutz',
        impressum: 'https://www.otto-schmidt.de/impressum',
      },
    },
  },

  [THEMES.MOHR_SIEBECK]: {
    label: 'LDH Explorer Theme – Mohr Siebeck',
    brandLabel: 'Mohr Siebeck AI',
    roleId: THEME_ROLES[THEMES.MOHR_SIEBECK],
    brandConfig: {
      brandLabel: 'Mohr Siebeck AI',
      website: 'https://www.mohrsiebeck.com/',
      companyName: 'Mohr Siebeck GmbH & Co. KG',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://www.mohrsiebeck.com/nutzungsbedingungen',
        datenschutz: 'https://www.mohrsiebeck.com/datenschutz',
        impressum: 'https://www.mohrsiebeck.com/impressum',
      },
    },
  },

  [THEMES.LINDE]: {
    label: 'LDH Explorer Theme – Linde Verlag AI',
    brandLabel: 'Linde Verlag AI',
    roleId: THEME_ROLES[THEMES.LINDE],
    brandConfig: {
      brandLabel: 'Linde Verlag AI',
      website: 'https://www.lindeverlag.at/de',
      companyName: 'Linde Verlag Ges.m.b.H.',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://www.lindeverlag.at/de/agb',
        datenschutz: 'https://www.lindeverlag.at/de/datenschutz',
        impressum: 'https://www.lindeverlag.at/de/impressum',
      },
    },
  },

  [THEMES.REHM]: {
    label: 'LDH Explorer Theme – rehm Verlag',
    brandLabel: 'REHM AI',
    roleId: THEME_ROLES[THEMES.REHM],
    brandConfig: {
      brandLabel: 'REHM AI',
      website: 'https://www.rehm-verlag.de',
      companyName: 'Hüthig Jehle Rehm GmbH',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://www.rehm-verlag.de/nutzungsbedingungen',
        datenschutz: 'https://www.rehm-verlag.de/datenschutz',
        impressum: 'https://www.rehm-verlag.de/shop/Impressum/',
      },
    },
  },

  [THEMES.REGUVIS]: {
    label: 'LDH Explorer Theme – Reguvis',
    brandLabel: 'Reguvis AI',
    roleId: THEME_ROLES[THEMES.REGUVIS],
    brandConfig: {
      brandLabel: 'Reguvis AI',
      website: 'https://www.reguvis.de/',
      companyName: 'Reguvis Fachmedien GmbH',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://www.reguvis.de/impressum',
        datenschutz: 'https://www.reguvis.de/datenschutzerkl%C3%A4rung',
        impressum: 'https://www.reguvis.de/impressum/',
      },
    },
  },

  [THEMES.STAEMPFLI]: {
    label: 'LDH Explorer Theme – Stämpfli Verlag',
    brandLabel: 'Stämpfli AI',
    roleId: THEME_ROLES[THEMES.STAEMPFLI],
    brandConfig: {
      brandLabel: 'Stämpfli AI',
      website: 'https://staempflirecht.ch/',
      companyName: 'Stämpfli Verlag AG',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://staempflirecht.ch/agb',
        datenschutz: 'https://staempflirecht.ch/datenschutz',
        impressum: 'https://staempflirecht.ch/impressum',
      },
    },
  },

  [THEMES.ERICH_SCHMIDT]: {
    label: 'LDH Explorer Theme – Erich Schmidt Verlag',
    brandLabel: 'Erich Schmidt Verlag AI',
    roleId: THEME_ROLES[THEMES.ERICH_SCHMIDT],
    brandConfig: {
      brandLabel: 'Erich Schmidt Verlag AI',
      website: 'https://www.esv.info/',
      companyName: 'Erich Schmidt Verlag GmbH & Co. KG',
      legalLinks: {
        disclaimer: '/disclaimer',
        nutzungsbedingungen: 'https://www.esv.info/geschaeftsbedingungen.html',
        datenschutz: 'https://datenschutzbestimmungen.esv.info/?domain=esv.info',
        impressum: 'https://www.esv.info/impressum.html',
      },
    },
  },

  [THEMES.NKR]: {
    label: 'LDH Explorer Theme – Normenkontrollrat',
    brandLabel: 'Bürokratie-Radar',
    roleId: THEME_ROLES[THEMES.NKR],
    brandConfig: {
      brandLabel: 'Bürokratie-Radar',
      website: 'https://www.legal-data-analytics.com/',
      companyName: 'Bayerischer Normenkontrollrat',
      legalLinks: {
        disclaimer: "/disclaimer",
        nutzungsbedingungen:
          "https://www.legal-data-analytics.com/impressum",
        datenschutz: "https://www.legal-data-analytics.com/privacy",
        impressum: "https://www.legal-data-analytics.com/impressum",
      },
    },
  },
};

export const THEME_ORDER = [
  THEMES.LDA_LIGHT,
  THEMES.LDA_DARK,
  THEMES.OTTO_SCHMIDT,
  THEMES.REHM,
  THEMES.MOHR_SIEBECK,
  THEMES.NKR,
  THEMES.STAEMPFLI,
  THEMES.ERICH_SCHMIDT,
  THEMES.LINDE,
  THEMES.REGUVIS,
];

